import { ReportParameters } from 'generated/graphql-types';
import { ParameterFormValueBase } from '../report-parameter-list/models/report-parameter-form-value';

export function createDateRangeReportParameter(
   value?: DateRangeReportParameterValue,
   sortOrder?: number | null
): DateRangeReportParameterValue {
   const now = new Date();
   let startDate: string | Date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
   let endDate: string | Date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

   if (value?.startDate) {
      startDate = value?.startDate;
   }
   if (value?.endDate) {
      endDate = value?.endDate;
   }

   return {
      endDate,
      startDate,
   };
}

export interface DateRangeReportParameterValue {
   startDate?: Date | string | null;
   endDate?: Date | string | null;
}

export const defaultDateParameter: DateRangeReportParameterValue = {
   endDate: null,
   startDate: null,
};

export interface DateRangeParameterFormModel extends ParameterFormValueBase, DateRangeReportParameterValue {
   parameterType: ReportParameters.DateRange;
}

export interface DateRangeSelectReportParameterValue extends DateRangeReportParameterValue {
   field?: string | null;
   filterByDateRange: boolean;
}

export interface DateRangeSelectParameterFormModel extends ParameterFormValueBase, DateRangeSelectReportParameterValue {
   parameterType: ReportParameters.DateRangeSelect;
}
